import React, { useState, useEffect } from "react";

import "./MittiReports.css";
import axios from "axios";
import Form_Modals from "./Form_Modal";
import { config } from "../../../confi";
import { Spinner } from "@chakra-ui/react";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';


function formatDate(date) {
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function Edit_form(prop) {
  let {
    miti_row,
    name_person,
    father_hus_name,
    address,
    mobile_no,
    email,
    membership_rec_no,
    membership_year,
    miti,
    balance,
    recieve_amount,
    total_amount,
    commit_amount,
  } = prop.Data;
const reload_fn = prop.reload_fn
const datapass = prop.datapass
const setmember_data = prop.setmember_data;


//-------------- total recieved amount calculation -------------------//

  let sum = 0;

  if (recieve_amount[0] !== null) {
    sum = recieve_amount.reduce((collect, currentValue) => {
      return collect + currentValue.amount;
    }, 0);
  }


  // if (recieve_amount?.length > 0 && recieve_amount.every(item => item !== null)) {
  //   sum = recieve_amount.reduce((collect, currentValue) => {
  //     return collect + currentValue.amount;
  //   }, 0);
  // }

  const [recievesumary, setrecievesummary] = useState(+sum);
  const [I_data, setI_data] = useState(recieve_amount);

  ///---- state for  regular--- ///
  const [regular, setregular] = useState(miti.regular ? miti.regular.type : 0);
  let [r_day, setr_day] = useState(
    regular ? (miti.regular?.days !== undefined ? miti.regular.days : 1) : 0
  );
  let [r_price, setr_price] = useState(
    regular
      ? miti.regular?.price !== undefined
        ? miti.regular.price
        : 21000
      : 0
  );
  let [r_amount, setr_amount] = useState(
    regular ? miti.regular?.amount ?? 0 : 0
  );

  ////----state for specail ---///
  const [Special, setSpecial] = useState(miti.Special ? miti.Special.type : 0);
  let [s_day, sets_day] = useState(
    Special ? (miti.Special?.days !== undefined ? miti.Special.days : 1) : 0
  );
  let [s_price, sets_price] = useState(
    Special
      ? miti.Special?.price !== undefined
        ? miti.Special.price
        : 51000
      : 0
  );
  let [s_amount, sets_amount] = useState(
    Special ? miti.Special?.amount ?? 0 : 0
  );

  ///////------state for olian -----///////
  const [Olian, setOlian] = useState(miti.Olian ? miti.Olian.type : 0);
  let [O_day, setO_day] = useState(
    Olian ? (miti.Olian?.days !== undefined ? miti.Olian.days : 1) : 0
  );
  let [O_price, setO_price] = useState(
    Olian ? (miti.Olian?.price !== undefined ? miti.Olian.price : 0) : 0
  );
  let [O_amount, setO_amount] = useState(Olian ? miti.Olian?.amount ?? 0 : 0);

  ///// ---------state for sponsor --/////////
  const [sponsor, setsponsor] = useState(miti.sponsor ? miti.sponsor.type : 0);
  let [spon_day, setspon_day] = useState(
    sponsor ? (miti.sponsor?.days !== undefined ? miti.sponsor.days : 1) : 0
  );
  let [spon_price, setspon_price] = useState(
    sponsor ? (miti.sponsor?.price !== undefined ? miti.sponsor.price : 0) : 0
  );
  let [spon_amount, setspon_amount] = useState(
    sponsor ? miti.sponsor?.amount ?? 0 : 0
  );

//////////---------other miti-----------------------------------////
const [other_miti,Setother_miti] = useState(miti.Other ? miti.Other.type:0)
let [other_amount,Setother_amount] = useState(miti.Other ? miti.Other.amount :0)
const [commited,SetCommited] = useState(commit_amount)
const [checkcommit,setCheckcommit] =useState(false)





  ///----------------------------------- other state -----///
 
  const [recieve, setrecieve] = useState(0);
  const [recieve_date, setrecieve_date] = useState(0);
  const [cash,setCash] = useState('');
  const [cheque_amount,setCheque_amount] = useState('')
  const [cheque_no,setCheque_no] = useState('')
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [Form_modal_show,SetForm_modal_show] = useState(false)
  const [amount_element,Setamount_element]  = useState('')
  const [index_id,Setindex_id] = useState('')

  ///-------------//////////////

  const [isHovering, setIsHovering] = useState(false);
  // const handleMouseOver = () => {
  //   setIsHovering(true);
  // };
  // const handleMouseOut = () => {
  //   setIsHovering(false);
  // };

const handlermodel = () =>{


isHovering? setIsHovering(false):setIsHovering(true)


}
//---------------- Form_modal show and hide  for update recieved amount in amounts list -----------------------//

const Form_modal_handler = (obj,i) =>{


   Setindex_id(i)
  Setamount_element(obj)
SetForm_modal_show(true)



}






  //  ---------/////

  
  useEffect(() => {
    setr_amount(parseInt(r_day) * parseInt(r_price));
  }, [r_day, r_price]);

  useEffect(() => {
    sets_amount(parseInt(s_day) * parseInt(s_price));
  }, [s_day, s_price]);

  useEffect(() => {
    setO_amount(parseInt(O_day) * parseInt(O_price));
  }, [O_day, O_price]);

  useEffect(() => {
    setspon_amount(parseInt(spon_day) * parseInt(spon_price));
  }, [spon_day, spon_price]);

  // ---input change handler ---------------------//

  const handle_input = (e) => {
    if (e.target.name === "regular") {
      setregular(e.target.checked ? 1 : 0);
      setr_day(e.target.checked ? 1 : 0);
      setr_price(e.target.checked ? 21000 : 0);
      // Debugging console logs

      setr_amount((prevAmount) =>
        e.target.checked ? parseInt(r_day) * parseInt(r_price) : 0
      );
    }

    if (e.target.name === "regu_price") {
      setr_price(e.target.value);
    }
    if (e.target.name === "regu_day") {
      setr_day(e.target.value);
    }

    if (e.target.name === "regu_amount") {
      setr_day(1);
      setr_amount(e.target.value);
    }

    /////---------------------------------------------special------------------------------------/////
    if (e.target.name === "special") {
      setSpecial(e.target.checked ? 2 : 0);
      sets_day(e.target.checked ? 1 : 0);
      sets_price(e.target.checked ? 51000 : 0);
      // Debugging console logs

      sets_amount((prevAmount) =>
        e.target.checked ? parseInt(s_day) * parseInt(s_price) : 0
      );
    }

    if (e.target.name === "spe_day") {
      sets_day(e.target.value);
    }
    if (e.target.name === "spe_amount") {
      sets_amount(e.target.value);
    }

    if (e.target.name === "spe_price") {
      sets_price(e.target.value);
    }

    ///-----------------------------Olian-----------------------------------////

    if (e.target.name === "Olian") {
      setOlian(e.target.checked ? 3 : 0);
      setO_day(e.target.checked ? 1 : 0);
      setO_price(e.target.checked ? 0 : 0);

      setO_amount((prevAmount) =>
        e.target.checked ? parseInt(O_day) * parseInt(O_price) : 0
      );
    }

    if (e.target.name === "O_day") {
      setO_day(e.target.value);
    }

    if (e.target.name === "O_price") {
      setO_price(e.target.value);
    }
    if (e.target.name === "O_amount") {
      setO_amount(e.target.value);
    }

    ///----------------------------sponsor----------------------------------/////
    if (e.target.name === "spon") {
      setsponsor(e.target.checked ? 4 : 0);
      setspon_day(e.target.checked ? 1 : 0);
      setspon_price(e.target.checked ? 0 : 0);
      // Debugging console logs

      setspon_amount((prevAmount) =>
        e.target.checked ? parseInt(spon_day) * parseInt(spon_price) : 0
      );
    }

    if (e.target.name === "spon_day") {
      setspon_day(e.target.value);
    }

    if (e.target.name === "spon_price") {
      setspon_price(e.target.value);
    }

    if (e.target.name === "spon_amount") {
      setspon_amount(e.target.value);
    }



    //-----------other mitt -----------//
    if(e.target.name ==="other_miti"){
      Setother_miti(other_miti === 0?5:0)
    }

    if(e.target.name ==="other_amount"){

      Setother_amount(e.target.value)
    }


//--------------------------///


if(e.target.name ==='commited'){

 
  if(e.target.value >= r_amount +
    O_amount +
    s_amount +
    spon_amount+Number(other_amount)){
  
      setCheckcommit(false)
    }
  
  else{
    setCheckcommit(true)
  }

  
    SetCommited(e.target.value)


}


    if (e.target.name === "receive") {
      setrecieve(e.target.value);
    }



if(e.target.name ==="cash"){

setCash(e.target.value)
setrecieve(+e.target.value +(+cheque_amount))

}




if(e.target.name ==="cheque_no"){

  setCheque_no(e.target.value)

}



if(e.target.name ==='cheque_am'){

  setCheque_amount(e.target.value)
  setrecieve(+e.target.value+(+cash))
}


  };

  
  // console.log("r-d-p-a", regular, r_day, r_price, r_amount);
  // console.log("s-d-p-a", Special, s_day, s_price, s_amount);
  // console.log("o-d-p-a", Olian, O_day, O_price, O_amount);
  // console.log("spon-d-p-a", sponsor, spon_day, spon_price, spon_amount);

  ///--------------------------////////////

  const submitHandler = async (e) => {
    e.preventDefault();
    let miti = {};

    let Regular;
    let special;
    let olian;
    let Sponsor;
    let others;
 
    let reci_am ={};


    if (regular === 1) {
      Regular = {
        type: regular,
        days: r_day,
        price: r_price,
        amount: r_day * r_price,
      };
      miti.regular = Regular;
    }

    if (Special === 2) {
      special = {
        type: Special,
        days: s_day,
        price: s_price,
        amount: s_day * s_price,
      };

      miti.Special = special;
    }

    if (Olian === 3) {
      olian = {
        type: Olian,
        days: O_day,
        price: O_price,
        amount: O_day * O_price,
      };
      miti.Olian = olian;
    }

    if (sponsor === 4) {
      Sponsor = {
        type: sponsor,
        days: spon_day,
        price: spon_price,
        amount: spon_day * spon_price,
      };

      miti.sponsor = Sponsor;
    }

    if(other_miti === 5){
    
      others = {
        type:other_miti,
        amount:other_amount
  
      }
  miti.Other = others
  
  
    }
  




    //  console.log(miti);

    let total = r_amount + s_amount + spon_amount + O_amount + Number(other_amount);

    let recieved = +recieve;

    // let Balanced = total - recievesumary - recieve;
    
    ///---- calculate balance amount ------///
    let Balanced = commit_amount ? commit_amount-total_amount+  r_amount +
    O_amount +
    s_amount +
    spon_amount + Number(other_amount) - (Number(recievesumary) +
    Number(recieve)):  total - recievesumary - recieve;

    let today = new Date();
    let formattedDate = recieve_date || formatDate(today);



    let commit_amounts = commit_amount? commit_amount-total_amount+  r_amount +
    O_amount +
    s_amount +
    spon_amount + Number(other_amount):0
  

    if (total === 0) {
      return;
    }


if(cash){

reci_am.cash =cash
}

   if(cheque_amount){

 reci_am.cheque_amount = cheque_amount
   }


   if(cheque_no){

    reci_am.cheq_no = cheque_no
   }

   if(recieve)
   {    
    reci_am.date = formattedDate
    reci_am.amount = +recieve
   
   }


if(!commited || commited < total){

  setCheckcommit(true)
  return
}


    let formdata = {
      row_id: miti_row,
      miti: miti,
      recieve_amount: recieved
        ? reci_am
        : null,
      total: total,
      balance: Balanced,
      commit_amount:commit_amounts

    };

    // console.log(formdata);

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_miti_up",
      payload: formdata,
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response);

      // console.log(response.data);
      if (response.status === 200 && response.data.status === "0") {

        Swal.fire({
          icon: 'success',
          title: 'Miti Updated!',
          text: 'Miti has been updated successfully.',
          timer: 2000, // The alert will automatically close after 2 seconds
        });

        setmsg("successfully Update");
      } else {
      }
    } catch (error) {}
    setLoading(false);
  };

  return (
    <>
      {loading ? (
       <Spinner/>
      ) : (
        <div>
          {msg ? (
            <p className="msg">{msg}</p>
          ) : (
            <div>
              <div className="report-fatch-border">
                <div className="Show-info">
                  <span> Member Name:&nbsp; {name_person}</span>
                  <span>Membership Year:&nbsp;{membership_year}</span>
                  <span>Mobile No:&nbsp; {mobile_no}</span>
                </div>
                <div>
                  <div className="Select-Mitti">Select Mitti</div>
                  <div>
                    <div className="mitti-days-amount">
                      <div className="chekbox-set-width">
                        <input
                          className="bb34"
                          // style={{ width: "auto" }}
                          type="checkbox"
                          name="regular"
                          onChange={(e) => handle_input(e)}
                          checked={regular}
                        ></input>
                        <label style={{ marginRight: "3em" }}>Regular</label>
                      </div>
                      <div>
                        <label>Mitti &nbsp;</label>
                        <input
                          className="Show-info-input-day"
                          style={{ width: "2em", marginRight: "3em" }}
                          type="text"
                          name="regu_day"
                          value={r_day}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                      <div className="price-flex">
                        <div>
                          <label>Price</label>
                          <input
                            className="price"
                            type="number"
                            name="regu_price"
                            value={r_price}
                            onChange={(e) => handle_input(e)}
                          ></input>
                        </div>
                        <div>
                          <label>Amount</label>
                          <input
                            className="price"
                            type="number"
                            name="regu_amount"
                            disabled={true}
                            value={r_amount}
                            onChange={(e) => handle_input(e)}
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="mitti-days-amount">
                      <div className="chekbox-set-width">
                        <input
                          className="bb34"
                          // style={{ width: "auto" }}
                          type="checkbox"
                          name="special"
                          checked={Special}
                          onChange={(e) => handle_input(e)}
                        ></input>
                        <label style={{ marginRight: "3em" }}>Special</label>
                      </div>
                      <div>
                        <label>Mitti &nbsp;</label>
                        <input
                          className="Show-info-input-day"
                          // style={{ width: "2em", marginRight: "3em" }}
                          type="text"
                          name="spe_day"
                          value={s_day}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                      <div className="price-flex">
                        <div>
                          <label>Price</label>
                          <input
                            className="price"
                            type="number"
                            name="spe_price"
                            value={s_price}
                            onChange={(e) => handle_input(e)}
                          ></input>
                        </div>
                        <div>
                          <label>Amount</label>
                          <input
                            className="price"
                            type="number"
                            name="spe_amount"
                            disabled={true}
                            value={s_day * s_price}
                            onChange={(e) => handle_input(e)}
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="mitti-days-amount">
                      <div className="chekbox-set-width">
                        <input
                          className="bb34"
                          // style={{ width: "auto" }}
                          type="checkbox"
                          name="Olian"
                          checked={Olian}
                          onChange={(e) => handle_input(e)}
                        />
                        <label style={{ marginRight: "3em" }}>Olian</label>
                      </div>
                      <div>
                        <label>Mitti &nbsp;</label>
                        <input
                          className="Show-info-input-day"
                          // style={{ width: "2em", marginRight: "3em" }}
                          type="text"
                          name="O_day"
                          value={O_day}
                          onChange={(e) => handle_input(e)}
                        />
                      </div>
                      <div className="price-flex">
                        <div>
                          <label>Price</label>
                          <input
                            className="price"
                            type="number"
                            name="O_price"
                            value={O_price}
                            onChange={(e) => handle_input(e)}
                          />
                        </div>
                        <div>
                          <label>Amount</label>
                          <input
                            className="price"
                            type="number"
                            name="O_amount"
                            disabled={true}
                            value={O_day * O_price}
                            onChange={(e) => handle_input(e)}
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="mitti-days-amount">
                      <div className="chekbox-set-width">
                        <input
                          className="bb34"
                          // style={{ width: "auto" }}
                          type="checkbox"
                          name="spon"
                          checked={sponsor}
                          onChange={(e) => handle_input(e)}
                        ></input>
                        <label>Sponsorship </label>
                      </div>
                      <div>
                        <label>Mitti &nbsp;</label>
                        <input
                          className="Show-info-input-day"
                          // style={{ width: "2em", marginRight: "3em" }}
                          type="text"
                          name="spon_day"
                          value={spon_day}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                      <div className="price-flex">
                        <div>
                          <label>Price</label>
                          <input
                            className="price"
                            type="number"
                            name="spon_price"
                            value={spon_price}
                            onChange={(e) => handle_input(e)}
                          />
                        </div>
                        <div>
                          <label>Amount</label>
                          <input
                            className="price"
                            type="number"
                            name="spon_amount"
                            disabled={true}
                            value={spon_day * spon_price}
                            onChange={(e) => handle_input(e)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mitti-days-amount">
                    <div className="chekbox-set-width">
                      <input
                        // style={{ width: "auto" }}
                        className="bb34"
                        type="checkbox"
                        name="other_miti"
                        value={other_miti}
                        checked={other_miti === 5}
                        onChange={(e) => handle_input(e)}
                      ></input>
                      <label style={{ marginRight: "3em" }}>Other </label>
                    </div>
                  
                    <div className="price-flex">
                      <div>
                        <label>Amount</label>
                        <input
                          className="price"
                          type="text"
                          name="other_amount"
                          value={other_amount}
                          onChange={(e) => handle_input(e)}
                        />
                      </div>
                    
                    </div>
                  </div> 




                  </div>
                </div>
                <div className="report-totel-amount-to-submit">
                  <div>
                    Total Amount :{" "}
                    {r_amount + s_amount + O_amount + spon_amount + Number(other_amount)} &nbsp;/-
                  </div>



{/* 
                  <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "1em" }}>
          Commited Amount :
                  </div>
                  <div>
                   <p>{commit_amount ? commit_amount-total_amount+  r_amount +
                      O_amount +
                      s_amount +
                      spon_amount + Number(other_amount):0}/-</p>
             
                  </div>
                </div>
                 */}

                     
                     <div className="Amount-date-flex">
                  <label style={{ width: "115px" }}>
                  Commited amount:&nbsp;
                  </label>
                  <input
                    className="Amount-date-input"
                    type="text"
                    name="commited"
                    value={commited}
                    onChange={(e) => handle_input(e)}
                  />
            

                </div>
                       {checkcommit&& <p style={{color:"red"}}>committed amount must not less than total amount</p>}



                  <div style={{ display: "flex" }}>
                    <div style={{ marginRight: "1em" }}>
                      Amount Received till Date:{" "}
                    </div>
                    <div>{recievesumary}&nbsp;/-</div>
                    <div className="oo" style={{ position: "relative" }}>
                      <button
                        className="i-button"
                        // onMouseOver={handleMouseOver}
                        // onMouseOut={handleMouseOut}
                        onClick={handlermodel}
                      >
                        i
                      </button>
                      {isHovering && I_data && (
                        <div className="after-i" >
                          {I_data.map((obj, i) => {
                            return (
                              <div key={i + 4} style={{marginTop:"2%"}}  onClick={()=>{
                                Form_modal_handler(obj,i)
                              }}>
                                <span>
                                 <b>{i+1}</b> - date: {obj.date} total-amount: {obj.amount} &nbsp;
                                </span>
                                 {/* (cash by: {obj?.cash}) &nbsp; */}
                                  {`${obj?.cash?`cash by: ${obj.cash},`:""}`}&nbsp;
                                <span>
                                 {/* cheq by: {obj?.cheque_amount} &nbsp; */}
                                 {`${obj?.cheque_amount?`cheq by: ${obj.cheque_amount},`:""}`}&nbsp;
                                </span>
                                <span>
                                {/* cheq no :{obj?.cheq_no} */}

                                {`${obj?.cheq_no?`cheq_no: ${obj.cheq_no}`:""}`}
                                </span>
                           
                  
                              </div>
                            );
                          })}
                     
                        </div>

            

                      )}

                    </div>
                   { Form_modal_show && <Form_Modals SetForm_modal_show ={SetForm_modal_show} dataObj = {amount_element}
                   index_id= {index_id} mitiid = {miti_row} balance ={balance} setLoading ={setLoading} reload_fn ={reload_fn}
                   
                   setmember_data={setmember_data} datapass ={datapass}


      

                   />}
               
                  </div>
                  <div>
                    Balance :{" "}
                    {
                    commited ? commited   - (Number(recievesumary) +
                    Number(recieve)) :

                    r_amount +
                      O_amount +
                      s_amount +
                      spon_amount+Number(other_amount) -
                      (+recievesumary +
                      recieve) }
                    &nbsp; /-
                  </div>
                </div>
              </div>

              <div className="Amount-date">
              <div className="Amount-date-flex">
                  <label style={{ width: "115px" }}>
                  Cash:&nbsp;
                  </label>
                  <input
                    className="Amount-date-input"
                    type="text"
                    name="cash"
                    value={cash}
                    onChange={(e) => handle_input(e)}
                  />
                </div>
          

                <div className="Amount-date-flex">
                  <label style={{ width: "115px" }}>
                  Cheque amount:&nbsp;
                  </label>
                  <input
                    className="Amount-date-input"
                    type="text"
                    name="cheque_am"
                    value={cheque_amount}
                    onChange={(e) => handle_input(e)}
                  />
                </div>
                <div className="Amount-date-flex">
                  <label style={{ width: "115px" }}>
                  Cheque-no:&nbsp;
                  </label>
                  <input
                    className="Amount-date-input"
                    type="text"
                    name="cheque_no"
                    value={cheque_no}
                    onChange={(e) => handle_input(e)}
                  />
                </div>

                <div className="Amount-date-flex">
                  <label style={{ width: "115px" }}>
                    Amount Received:&nbsp;
                  </label>
                  <input
                    className="Amount-date-input"
                    type="number"
                    name="receive"
                    value={recieve}
                    onChange={(e) => handle_input(e)}
                    readOnly
                  />
                </div>
                <div className="Amount-date-flex">
                  <label style={{ width: "115px" }}>Date:&nbsp;</label>
                  <input
                    className="Amount-date-input"
                    type="date"
                    value={recieve_date}
                    onChange={(e) => {
                      setrecieve_date(e.target.value);
                    }}
                  ></input>
                </div>
              </div>
              <button style={{ margin: "1em 0em" }} onClick={submitHandler}>
                submit
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
export default Edit_form;
